import { inject, Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { environment } from '../../environments/environment';
import { TokenService } from '../pages/login/services/token.service';

@Injectable({
  providedIn: 'root',
})
export class FileDownloadService {
  private readonly oauth = inject(OAuthService);
  private readonly tokenService = inject(TokenService);

  /**
   * Descarga un archivo autenticado desde una URL relativa al API.
   *
   * @param relativePath  Ruta relativa al `api_url` (ej. `/exports/errors/123`)
   * @param fileName      Nombre con el que se guardará el archivo descargado
   */
  download(relativePath: string, fileName: string): void {
    const url = environment.api_url + relativePath;
    const headers = this.buildAuthHeaders();

    fetch(url, { headers })
      .then(response => response.blob())
      .then(blob => {
        const objectUrl = URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = objectUrl;
        anchor.setAttribute('download', fileName);
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
        URL.revokeObjectURL(objectUrl);
      });
  }

  private buildAuthHeaders(): Record<string, string> {
    const headers: Record<string, string> = {};

    if (environment.keycloak_login) {
      const token = this.oauth.getAccessToken();
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }
    } else {
      const sessionId = this.tokenService.getToken();
      if (sessionId) {
        headers['session-id'] = sessionId;
      }
    }

    return headers;
  }
}
